import { Card } from "@/components/kit";

// Lightweight responsive table used across admin views.
export const AdminTable = ({ columns, rows, testId, empty = "Sin registros", rowClassName }) => (
  <Card className="overflow-x-auto p-0" testid={testId}>
    <table className="w-full min-w-[640px] text-left text-sm" data-testid={testId}>
      <thead>
        <tr className="border-b border-[#27272A] text-xs uppercase tracking-wider text-gray-500">
          {columns.map((c) => (
            <th key={c.key} className="px-4 py-3 font-bold">{c.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="px-4 py-10 text-center text-gray-500">{empty}</td>
          </tr>
        ) : (
          rows.map((r, i) => (
            <tr key={r.id || i} className={`border-b border-[#1a1a1c] transition-colors hover:bg-[#18181B] ${rowClassName ? rowClassName(r) : ""}`} data-testid={`row-${r.id || i}`}>
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-3 align-middle text-gray-200">
                  {c.render ? c.render(r) : r[c.key] ?? "—"}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </Card>
);
